import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const FaturaVerileriYukle = () => {
    return (
        <>
            <ExcelUpload
                role_name={"fatura_giris_write"}
                requiredColumnsSase={[
                    "sase", "Client invoice date", "Client name",
                    "Client code", "Original invoice number", "MAD date"
                ]}
                // Vin	Client invoice date	Client name	Client code	Original invoice number	MAD date

                process_type="INVOICE"
                ExcelName={"Hatalı Fatura Verileri"}
                Title={"Fatura Verileri"}
                exampleData={[
                    {
                        sase: "VR3USHNS7RJ793212",
                        "Client invoice date": "01.01.2025",
                        "Client name": "AĞAÇLI",
                        "Client code": "00291",
                        "Original invoice number": "01366482",
                    }
                ]}
            />
        </>
    )
}

export default FaturaVerileriYukle